export interface AccountSessionDetails {
  browser: string;
  operatingSystem: string;
  label: string;
}

export function describeAccountSession(userAgent: string | null | undefined): AccountSessionDetails {
  const agent = userAgent ?? '';
  const browser = getBrowserName(agent);
  const operatingSystem = getOperatingSystemName(agent);

  return {
    browser,
    operatingSystem,
    label: `${browser} on ${operatingSystem}`,
  };
}

function getBrowserName(userAgent: string) {
  if (/edg\//i.test(userAgent)) return 'Microsoft Edge';
  if (/opr\//i.test(userAgent) || /opera/i.test(userAgent)) return 'Opera';
  if (/firefox|fxios/i.test(userAgent)) return 'Firefox';
  if (/crios/i.test(userAgent)) return 'Chrome';
  if (/chrome|chromium/i.test(userAgent)) return 'Chrome';
  if (/safari/i.test(userAgent)) return 'Safari';
  return 'Unknown browser';
}

function getOperatingSystemName(userAgent: string) {
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'iOS';
  if (/android/i.test(userAgent)) return 'Android';
  if (/windows/i.test(userAgent)) return 'Windows';
  if (/macintosh|mac os/i.test(userAgent)) return 'macOS';
  if (/linux/i.test(userAgent)) return 'Linux';
  return 'Unknown device';
}
